import BaseService from "@/boot/BaseService";
class FuerzaVentaService extends BaseService {
    constructor() {
        super(null, "/fuerza-venta");
    }
    async index() {
        return await this.get("/");
    }


}

export default new FuerzaVentaService();
